/**
 * IAB Full Taxonomy Types
 *
 * Complete IAB Audience Taxonomy 1.1 with 1,558 entries.
 * 5-tier hierarchical structure for demographic, household, interests, and purchase intent.
 *
 * Based on IABTL-Audience-Taxonomy-1.1-Final.xlsx
 */
/**
 * IAB Taxonomy Section Types
 */
export var TaxonomySection;
(function (TaxonomySection) {
    TaxonomySection["DEMOGRAPHICS"] = "demographics";
    TaxonomySection["HOUSEHOLD_DATA"] = "household_data";
    TaxonomySection["PERSONAL_ATTRIBUTES"] = "personal_attributes";
    TaxonomySection["PERSONAL_FINANCE"] = "personal_finance";
    TaxonomySection["INTERESTS"] = "interests";
    TaxonomySection["PURCHASE_INTENT"] = "purchase_intent";
})(TaxonomySection || (TaxonomySection = {}));
/**
 * Helper function to get the deepest classification value from a taxonomy entry
 *
 * Returns tier_5 if present, else tier_4, else tier_3, etc.
 */
export function getTaxonomyValue(entry) {
    if (entry.tier_5)
        return entry.tier_5;
    if (entry.tier_4)
        return entry.tier_4;
    if (entry.tier_3)
        return entry.tier_3;
    if (entry.tier_2)
        return entry.tier_2;
    return entry.tier_1;
}
/**
 * Helper function to build category path from taxonomy entry
 */
export function buildCategoryPath(entry) {
    const parts = [];
    if (entry.tier_1)
        parts.push(entry.tier_1);
    if (entry.tier_2)
        parts.push(entry.tier_2);
    if (entry.tier_3)
        parts.push(entry.tier_3);
    if (entry.tier_4)
        parts.push(entry.tier_4);
    if (entry.tier_5)
        parts.push(entry.tier_5);
    return parts.join(' | ');
}
/**
 * Helper function to get tier depth (1-5)
 */
export function getTierDepth(entry) {
    if (entry.tier_5)
        return 5;
    if (entry.tier_4)
        return 4;
    if (entry.tier_3)
        return 3;
    if (entry.tier_2)
        return 2;
    return 1;
}
/**
 * Helper to check if entry is a leaf node (no children)
 */
export function isLeafNode(entry, allEntries) {
    return !allEntries.some(e => e.parent_id === entry.id);
}
//# sourceMappingURL=iab-full-taxonomy.js.map